"use strict";
var TO_STRING_TAG_SUPPORT = require("../internals/to-string-tag-support");
var defineBuiltIn = require("../internals/define-built-in");
var toString = require("../internals/object-to-string");
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, "toString", toString, { unsafe: true });
}
